import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  IconButton,
  Typography,
  styled,
} from "@mui/material";

// Main card styling - similar to ClientInfoCards
export const StyledCard = styled(Card)(({ theme }) => ({
  height: "100%",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(2),
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  transition: "box-shadow 0.3s ease",
  marginBottom: theme.spacing(3),
  "&:hover": {
    boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
  },
}));

// Header for cards - similar to ClientInfoCards
export const CardHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper, // Subtle background color
}));

// Content area for cards
export const CardContentWrapper = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  "&:last-child": {
    paddingBottom: theme.spacing(3),
  },
}));

// Header for the recipe page
export const RecipeHeaderCard = styled(Card)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(2),
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  marginBottom: theme.spacing(3),
}));

// Styled section titles
export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  marginBottom: theme.spacing(1),
  color: theme.palette.primary.main,
  display: "flex",
  alignItems: "center",
  "& svg": {
    marginRight: theme.spacing(1),
  },
}));

// Container for content sections
export const ContentBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

// Action button styling - similar to ClientInfoCards
export const ActionButton = styled(Button)(() => ({
  borderRadius: 20,
  padding: "8px 20px",
  textTransform: "none",
  fontWeight: 600,
}));

// Stats chip styling
export const StatsChip = styled(Chip)(({ theme }) => ({
  margin: theme.spacing(0.5),
  fontWeight: 500,
}));

// Image container styling
export const ImageContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  borderRadius: theme.spacing(2),
  overflow: "hidden",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  transition: "transform 0.3s ease",
  "&:hover": {
    transform: "scale(1.01)",
  },
}));

// Styled icon button
export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: "white",
  backgroundColor: theme.palette.primary.main + "99", // Semi-transparent
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
  },
  position: "absolute",
  bottom: theme.spacing(2),
  right: theme.spacing(2),
}));
